// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2NXEp","filesListContainer":"PosDisputesFiles_filesListContainer__1dcAo","filesButton":"PosDisputesFiles_filesButton__224YY"};